import type { CSSProperties } from 'react';
import { sidebarConfig, useSidebarOpenState } from '@backstage/core-components';
import { Link } from '@backstage/ui';
import { LogoFull } from './LogoFull';
import { LogoIcon } from './LogoIcon';
import styles from './SidebarLogo.module.css';

// `sidebarConfig` is plain numbers upstream, so the CSS module reads them as
// custom properties rather than restating them and drifting.
const sizing = {
  '--sidebar-logo-width': `${sidebarConfig.drawerWidthClosed}px`,
  '--sidebar-logo-height': `${3 * sidebarConfig.logoHeight}px`,
} as CSSProperties;

export const SidebarLogo = () => {
  const { isOpen } = useSidebarOpenState();

  return (
    <div className={styles.root} style={sizing}>
      <Link href="/" className={styles.link} aria-label="Home">
        {isOpen ? <LogoFull /> : <LogoIcon />}
      </Link>
    </div>
  );
};
